import * as React from 'react'
import '../../css/page/dropdown.css'

let current_operation_instance = null
// 下拉组件
export class Dropdown extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      isShow: false,
      _instance_id: Date.now() + Math.random()
    }
    this.hideDropList = this.hideDropList.bind(this)
    this.handleClick = this.handleClick.bind(this)
    this.handleOtherClick = this.handleOtherClick.bind(this)
  }

  componentDidMount() {
    window.addEventListener('click', this.hideDropList, false)
    window.addEventListener('click_dropdown', this.handleOtherClick )
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.hideDropList, false)
    window.removeEventListener('click_dropdown', this.handleOtherClick)
  }

  hideDropList() {
    setTimeout(() => {
      this.setState({
        isShow: false,
      })
    },50)
  }
  handleOtherClick() {
    if (current_operation_instance !== this.state._instance_id) {
      this.setState({
        isShow: false,
      })
    }
  }

  handleClick () {
    const { isShow } = this.state;
    current_operation_instance = this.state._instance_id
    this.setState({
      isShow: !isShow
    });
    window.dispatchEvent(new Event('click_dropdown'))
  }

  render () {
    const { isShow } = this.state;
    return <div>
      <div className={'dropdown-label'} onClick={(e) => {
        e.stopPropagation()
        this.handleClick()
      }}>
        {this.props.children}
      </div>
      {isShow && <div className={'dropdown-drop-list-wrap'}>
        <div className={'dropdown-drop-list'}>
          {this.props.droplist}
        </div>
      </div>}
    </div>
  }
}



// WEBPACK FOOTER //
// ./src/components/dropdown/index.js